module.exports = __webpack_public_path__ + "img/image_2021_06_18T06_28_27_366Z.ee7c63a5.png";